import { CSSProperties, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Icons, IconType } from '../../../constants/icons';
import { Profile } from '../../../models/UserStore';
import { AvatarNode } from '../AvatarNode';
import { JoyajoyImage } from '../JoyajoyImage';
import './SpaceCard.css';

export type SpaceCardProps = {
  banner: string;
  icon: string;
  classroomName: string;
  postCount: number;
  followerCount: number;
  playCount: number;
  memberTotalCount: number;

  ownerProfile?: Profile | undefined | null;
  style?: CSSProperties;
};

export const SpaceCard = memo(
  ({
    // banner,
    icon,
    classroomName,
    // postCount,
    // followerCount,
    playCount,
    memberTotalCount,
    ownerProfile,
    style,
  }: SpaceCardProps) => {
    const { t } = useTranslation();
    return (
      <div className="space-card" style={{ ...style }}>
        <div className="large-image-container">
          {/* <JoyajoyImage resource={{ uri: banner }} className={'large-image'} /> */}
          <JoyajoyImage
            resource={{ uri: icon }}
            className={'large-image'}
            style={{ borderRadius: '50%', border: '1px #E5E5E5 solid' }}
          />
        </div>
        <hr />
        <div className="content">
          <div className="flex flex-col" style={{ gap: '0.25rem' }}>
            <p className="first-text">{classroomName}</p>
            <p className="second-text">
              {t('{playsCount} Plays・{followerCount} Followers', {
                playsCount: playCount,
                followerCount: memberTotalCount,
              })}
            </p>
            {ownerProfile ? (
              <div className="third-text">
                <AvatarNode
                  avatar={{
                    ...ownerProfile?.avatar,
                    userId: ownerProfile?.userId,
                    source:
                      ownerProfile.profilePicture &&
                      ownerProfile.profilePicture.publicUrls?.small
                        ? {
                            uri: ownerProfile.profilePicture.publicUrls?.small,
                          }
                        : '',
                  }}
                  size={28}
                />
                {ownerProfile.name}
                {ownerProfile.isVerified && (
                  <img className="right-icon" src={Icons[IconType.Certified]} />
                )}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  },
);
